import { useLingui } from '@lingui/react/macro';
import { Stack } from '@mui/material';
import { useCandlestickChartStore } from '../../../../features/tv_charts/CandlestickChartStore';
import { CHART_OVERLAY_PREFERENCE_ITEMS, type ChartOverlayKey } from '../../../../features/tv_charts/chartOverlayConfig';
import { PreferenceSection } from './preference_section.tsx';
import { PreferenceSwitch } from './preference_switch.tsx';

export function ChartOverlayPreferencesSection() {
  const { t } = useLingui();
  const overlayVisibility = useCandlestickChartStore((state) => state.overlayVisibility);
  const setOverlayVisibility = useCandlestickChartStore((state) => state.setOverlayVisibility);

  const overlayLabels: Record<ChartOverlayKey, string> = {
    tradeMarks: t({ comment: 'Chart overlay preference', message: 'Buy / Sell marks' }),
    position: t({ comment: 'Chart overlay preference', message: 'Position' }),
    limitOrders: t({ comment: 'Chart overlay preference', message: 'Limit orders' }),
    stopOrders: t({ comment: 'Chart overlay preference', message: 'Stop orders' }),
    positionTpSl: t({ comment: 'Chart overlay preference', message: 'TP / SL' }),
  };

  return (
    <PreferenceSection title={t({ comment: 'Preferences: chart overlays section title', message: 'Chart' })}>
      <Stack gap={1}>
        {CHART_OVERLAY_PREFERENCE_ITEMS.map((item) => (
          <PreferenceSwitch
            key={item.key}
            label={overlayLabels[item.key]}
            checked={overlayVisibility[item.key]}
            onChange={(checked) => setOverlayVisibility(item.key, checked)}
          />
        ))}
      </Stack>
    </PreferenceSection>
  );
}
